// extracted by mini-css-extract-plugin
module.exports = {"bg":"_3rd-party-retailers_bg__1yafo","copy":"_3rd-party-retailers_copy__3mM_m","heading":"_3rd-party-retailers_heading__ISUpx"};